// AppRouter.js
import React, { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "../pages/auth/login";
import Signup from "../pages/auth/signup";
import ProtectedRoute from "../router/protectedRoutes";
import Home from "../pages/home";
import { Navigate } from "react-router-dom";
import TopNavBar from "../components/TopNavBar/TopNavBar";
import Footer from "../components/Footer";
import SearchList from "../pages/searchList";
import SearchDetail from "../pages/searchDetails";
import AllTrips from "../pages/trips/alltrips";
import TripPlanner from "../pages/trips/tripPlanner";
import BookingReview from "../pages/bookingReview";
import Explore from "../pages/explore";
import ScrollToTop from "../utils/scrollToTop";
import NewsRoom from "../pages/newsRooms";
import UserProfile from "../pages/profilePage";
import { useDispatch } from "react-redux";
import { unknownLogin, logout } from "../redux/slices/auth";
import BookingConfirmation from "../pages/BookingConfirmation";
import NewsRoomDetails from "../pages/newsRoomsDetails";
import Faq from "../pages/Faq";
import AboutUs from "../pages/AboutUs";
import AffiliateProgram from "../pages/AffiliateProgram";
import TermsAndConditions from "../pages/TermsandConditions";
import Privacypolicy from "../pages/PrivacyPolicy";
import usePageTracking from "../usePageTracking";
const AppRouter = () => {
  usePageTracking();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const noFooterPaths = ["/login", "/signup", "/search-list"];
  const noHeaderPaths = ["/login", "/signup"];
  let showHeader = !noHeaderPaths.includes(location.pathname);
  const showFooter = !noFooterPaths.includes(location.pathname);
  showHeader = !location.pathname.includes("signup");
  const queryParams = new URLSearchParams(location.search);
  const authToken = queryParams.get("auth");
  const oc = queryParams.get("oc");
  const cid = queryParams.get("cid");
  const sid = queryParams.get("sid");
  useEffect(() => {
    if (authToken) {
      localStorage.setItem("token", authToken);
      // dispatch(unknownLogin(authToken));
      unknownLogin(authToken);
      const newPath = `/review-booking/?oc=${oc}&cid=${cid}&sid=${sid}`;
      navigate(newPath);
    }
  }, [authToken, unknownLogin]);
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        dispatch(logout());
        navigate("/login");
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dispatch]);
  return (
    <>
      <ScrollToTop />
      {showHeader && <TopNavBar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup/:referral" replace element={<Signup />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/affiliate/*" element={<AffiliateProgram />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/news-room" element={<NewsRoom />} />
        <Route path="/news-details" element={<NewsRoomDetails />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/search-list" element={<SearchList />} />
        <Route path="/hotel" element={<SearchDetail />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route exact path="/" element={<ProtectedRoute />}>
          <Route path="/review-booking" element={<BookingReview />} />
          <Route path="/trips" element={<AllTrips />} />

          <Route path="/trip-planner" element={<TripPlanner />} />

          <Route path="/user-profile" element={<UserProfile />} />

          <Route
            path="/booking-confirmation"
            element={<BookingConfirmation />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
};

export default AppRouter;
